<template>
    <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-7">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div class="text-muted text-center mb-3">
                                <small>Fazer login utilizando</small>
                            </div>
                            <auth-social-component></auth-social-component>
                        </template>
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Ou acesse com suas credenciais</small>
                            </div>
                            <form role="form" @submit.prevent method="get">
                                <base-input alternative
                                            v-model="inputs.username"
                                            id="username"
                                            class="mb-3"
                                            placeholder="Usuário ou E-mail"
                                            addon-left-icon="fa fa-user">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            id="password"
                                            v-model="inputs.password"
                                            placeholder="Senha"
                                            addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <div class="text-center">
                                    <base-button nativeType="submit" @click="login($event)" type="primary" class="my-4">Acessar</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <div class="row mt-3">
                        <div class="col-6">
                            <router-link to="/redefinir-senha" class="text-light">
                                <small>Esqueceu sua Senha?</small>
                            </router-link>
                        </div>
                        <div class="col-6 text-right">
                            <router-link to="/registrar" class="text-light">
                                <small>Criar uma Conta</small>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { userMixin } from "@/mixins/userMixin";
import AuthSocialComponent from "./Social/AuthSocialComponent";

export default {
  name: "auth-component",
  mixins: [userMixin],
  components: {
    AuthSocialComponent
  },
  computed: {
    ...mapGetters('auth', [
        'isAuthenticated',
      ]),
    ...mapGetters('modal', [
        'showModal',
      ]),
  },
  beforeRouteLeave(to, from, next) {  
    this.inputs.username = null;
    this.inputs.password = null;
  },
  data() {
    return {
      inputs: {
        username: null,
        password: null,
      },
      modal: {
        title: 'Acesso Negado!', 
        body: 'Não foi possível completar a operação', 
        classe: 'modal-danger',
        icon: 'fa fa-lock', 
        okButton: 'OK',
      },
    };
  },
};
</script>
<style>
</style>
